export default {
  dashboard: {
    id: 1,
    label: 'Dashboard',
    path: '/dashboard',
    icon: 'dashboard'
  },
  carriers: {
    id: 2,
    label: 'Carriers',
    path: '/carriers',
    icon: 'directions_bus'
  },
  quotes: {
    id: 3,
    label: 'Quotes',
    path: '/quotes',
    icon: 'card_travel'
  },
  followups: {
    id: 4,
    label: 'Followups',
    path: '/followups',
    icon: 'schedule',
    color: 'brand2'
  },
  orders: {
    id: 5,
    label: 'Orders',
    path: '/orders',
    icon: 'card_giftcard',
    color: 'brand3'
  },
  dispatch: {
    id: 6,
    label: 'Dispatch',
    path: '/dispatch',
    icon: 'local_shipping',
    color: 'red-14'
  },
  reports: {
    id: 7,
    label: 'Reports',
    path: '/reports',
    icon: 'event_note',
    color: 'deep-purple-10'
  },
  users: {
    id: 8,
    label: 'Users',
    path: '/users',
    icon: 'people'
  },
  taq: {
    id: 9,
    label: 'Pricing',
    path: '/taq',
    icon: 'attach_money'
  },
  priceCheck: {
    id: 10,
    label: 'Price Check',
    path: '/price-check',
    icon: 'price_check'
  },
  settings: {
    id: 11,
    label: 'Settings',
    path: '/settings',
    icon: 'settings'
  },
  surveyList: {
    id: 13,
    label: 'Survey',
    path: '/survey-list',
    icon: 'warning'
  }
};
